import { encryptData, decryptData } from "../scripts/cryptoData";

export default function useStorage(){
    function isWrapped(value) {
        return Boolean(
            value &&
            typeof value === 'object' &&
            value.__meta &&
            typeof value.__meta === 'object' &&
            Object.prototype.hasOwnProperty.call(value, 'data')
        );
    }

    function isExpired(meta) {
        if (!meta || typeof meta.expiresAt !== 'number') {
            return false;
        }

        return Date.now() > meta.expiresAt;
    }

    function parseRaw(tag) {
        const encrypted = localStorage.getItem(tag);
        const decrypted = decryptData(encrypted);

        if (!decrypted) {
            return null;
        }

        try {
            return JSON.parse(decrypted);

        } catch {
            return null;
        }
    }

    function get(tag){
        const parsed = parseRaw(tag);

        if (!isWrapped(parsed)) {
            return parsed;
        }

        if (isExpired(parsed.__meta)) {
            localStorage.removeItem(tag);
            return null;
        }

        return parsed.data;
    }

    function save(tag, data){
        const saveData = encryptData(JSON.stringify(data));
        localStorage.setItem(tag, saveData);
        return;
    }

    function saveWithTTL(tag, data, ttlInSeconds){
        const payload = {
            __meta: {
                expiresAt: Date.now() + (ttlInSeconds * 1000),
            },
            data,
        };

        const saveData = encryptData(JSON.stringify(payload));
        localStorage.setItem(tag, saveData);
        return;
    }

    function exclude(tag){
        localStorage.removeItem(tag);
        return;
    }

    function clear(){
        localStorage.clear();
        return;
    }

    return {
        get,
        save,
        saveWithTTL,
        exclude,
        clear
    }
}
